import React, { useMemo } from "react";
import { isNumber } from "lodash";

import ExecutorReport from "../../../../../../../../../../services/ExecutorReport";
import formatNumber from "../../../../../../../../../../utils/formatNumber";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

export const cellProcessing = (
	item: InvoiceAmountCellContent.Props["item"],
) => {
	if (!isNumber(item?.ordersCounters?.invoice?.amount)) return "";
	return formatNumber(item?.ordersCounters?.invoice?.amount);
};

const InvoiceAmountCellContent: React.FC<InvoiceAmountCellContent.Props> = ({
	item,
}) => {
	const content = useMemo(() => cellProcessing(item), [item]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace InvoiceAmountCellContent {
	interface Props {
		item: ExecutorReport.Model;
	}
}

export default InvoiceAmountCellContent;
